import { merge } from '../../helper';
import * as exElement from '../../utils/element';

import alreadyTableHead from './utils/alreadyTableHead';
import type { TypeTableConfig } from './types';

// ----------------------------------------------------------------------------

function columns(element: HTMLElement, config: TypeTableConfig = {}): void {
    const defConfig: Record<string, any> = {
        columns: [],
        thead: {},
    };

    merge(defConfig, config);

    const src: Record<string, any> = {
        list: [],
    };

    for (const itemColumn of defConfig.columns) {
        if (itemColumn?.constructor === Object) {
            if (!itemColumn.title) {
                continue;
            }

            const defConfigItem: Record<string, any> = {};

            merge(defConfigItem, defConfig.thead.cell);
            merge(defConfigItem, itemColumn);

            const elCell = exElement.create({
                merge: defConfigItem,
                tag: 'th',
            }) as HTMLTableCellElement;

            src.list.push(elCell);

            if (itemColumn.title != null) {
                elCell.innerHTML = itemColumn.title;
            }

            if (itemColumn.width != null) {
                elCell.style.width = itemColumn.width;
            }
        } else {
            const elCell = exElement.create({
                merge: defConfig.thead.cell,
                tag: 'th',
                html: itemColumn,
            }) as HTMLTableCellElement;

            src.list.push(elCell);
        }
    }

    if (src.list.length > 0) {
        const elTableHead = alreadyTableHead(element, defConfig.thead);
        const elRow = exElement.create({
            merge: defConfig.thead.row,
            tag: 'tr',
        });

        elTableHead.appendChild(elRow);
        elRow.appendChildren(src.list);
    }
}

// ----------------------------------------------------------------------------

export { columns };
